







import { Vue, Component } from 'vue-property-decorator'

@Component
export default class App extends Vue {
  protected loading: boolean = true

  public async mounted () {
    this.loading = false
  }
}
